import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FornecimentoDiretoDetalheItem } from '@gestor-web/@core/api/ords/model';

@Component({
    selector: 'bl-fornecimento-item-group-cell',
    templateUrl: './item-group-cell.component.html',
    styleUrls: ['./item-group-cell.component.scss'],
    standalone: false
})
export class ItemGroupCellRenderer implements ICellRendererAngularComp {
  params: ICellRendererParams<FornecimentoDiretoDetalheItem>;
  data: FornecimentoDiretoDetalheItem;
  displayValue: string;
  empty: boolean;

  constructor() {}

  agInit(params: ICellRendererParams<FornecimentoDiretoDetalheItem>): void {
    this.updateValue(params);
  }

  refresh(params: ICellRendererParams<FornecimentoDiretoDetalheItem>) {
    this.updateValue(params);
    return true;
  }

  updateValue(params: ICellRendererParams<FornecimentoDiretoDetalheItem>) {
    this.params = params;
    this.data = params.data;
    this.displayValue = params.valueFormatted ?? params.value;
    this.empty = true;
    if (params.data?.motivos_rejeicao_item?.length) {
      this.empty = false;
    }
  }
}
